<template>
  <div>
    <MobialisFancyRadio
      v-if="!getLoadingBoolean"
      v-model="model"
      name="modelOptions"
      @buttonClicked="buttonClicked"
      :textArray="modelOptions"
    >
    </MobialisFancyRadio>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import log from '@/services/log';

export default {
  name: 'SelectionModel',
  methods: {
    ...mapActions(['insurance/getInsuranceModels']),
    buttonClicked(value) {
      if (value === this.model) {
        this.$router.push({ name: `insurance-personal-form-${this.baseRoute}` });
      }
    },
  },
  computed: {
    ...mapGetters(['insurance/getInsuranceModelOptions', 'getLoadingBoolean']),
    model: {
      get() {
        return this.$store.state.insurance.insurance.insuranceVehicle.model;
      },
      set(value) {
        if (value !== this.$store.state.insurance.insurance.insuranceVehicle.model) {
          this.$store.commit('insurance/SET_INSURANCE_VEHICLE_MODEL', value);
          this.$router.push({ name: `insurance-personal-form-${this.baseRoute}` });
        }
      },
    },
    modelOptions() {
      return this['insurance/getInsuranceModelOptions'];
    },
  },
  async created() {
    try {
      await this['insurance/getInsuranceModels']();
    } catch (error) {
      this.$store.commit('SET_LOADING', false);
      log('Error in Insurance Selection Model', error);
      this.$router.push({ name: `insurance-error-${this.baseRoute}` });
    }
  },
};
</script>

<style scoped lang="scss"></style>
